import { defineComponent as _defineComponent } from 'vue'
import {nextTick, onActivated, onMounted, ref} from 'vue';
import {Vue3SeamlessScroll} from 'vue3-seamless-scroll';
import {
    getBanner,
    getNoticeList,
    getPopularRecommen,
    getHomeCategory,
    getHomeList,
    getWechatAppUrl,
    getListAdd,
    getUserInfo,
    getIsFollow,
} from '@/api/miscellaneous';
import {useRouter} from 'vue-router';
import VipTag from '@/components/VipTag.vue';
import userStoreModule from '@/store/modules/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const noticeEnum = ref({
    0: {name: '求购', color: '#FF6666', listPath: 'seek', path: 'orderDetailSeekByUser'},
    1: {
        name: '工程',
        color: '#00B4FF',
        path: 'publishCooperateDetailByUser',
        listPath: 'projectSeek',
    },
    2: {name: '供应', color: '#FEC819', path: 'itemDetail', listPath: 'supple'},
    3: {
        name: '特价',
        color: '#FF9D4D',
        path: 'bargainDetail',
        listPath: 'bargainList',
    },
    96: {name: '活动', color: '#FF4834', path: 'vip'},
    99: {name: '店铺', color: '#38D09F', path: 'sellerShop', listPath: 'seller'},
});
const showregister = ref(false);
const addList = ref<any[]>([]);

const list = ref<any[]>([]);
const getListData = ref({
    page: 1,
    size: 10,
    keyword: '',
});
const loading = ref(false);
const finished = ref(false);
const images = ref<any[]>([]);
const noticeList = ref<any[]>([]);
const noticeIndex = ref(0);
const seamlessWidth = ref(0);
const popularItem = ref();
const popularRecommenList = ref<any[]>([]);
const categoryList = ref<any[]>([]);
const isSearchTypeShow = ref(false);
const searchTypes = ref([
    {text: '供应', value: 'SupplyList'},
    {text: '求购', value: 'WantToBuy'},
]);
const searchType = ref({text: '供应', value: 'SupplyList'});
const searchWord = ref('');

onMounted(() => {
    showpop();
});
onActivated(() => {
    showpop();
});

const showpop = async () => {
    console.log(userStoreModule.isLogin, '--isLogin');
    if (userStoreModule.isLogin) {
        let userinfo = await userStoreModule.getUserInfo();
        let id = userinfo?.user?.id;
        if (id != undefined) {
            getIsFollow(id).then((res: any) => {
                let ct = res.categoryTitle;
                if (JSON.stringify(ct) === '{}') {
                    showregister.value = true;
                }
            });
        } else {
            showregister.value = true;
        }
    } else {
        //不是显示出来，而是直接去登录
        showregister.value = true;
    }
};

const close = () => {
    showregister.value = false;
};

const getAdd = () => {
    getListAdd({keywords: '广告位用勿动处理求购供应列表中'}).then((res: any) => {
        addList.value = JSON.parse(res.contentJson);
    });
};
getAdd();

const getBannerList = async () => {
    const res: any = await getBanner();
    images.value = res;
};
getBannerList();
const getNotice = async () => {
    const res: any = await getNoticeList();
    noticeList.value = res.items;
};
getNotice();

const noticeChange = (index: number) => {
    noticeIndex.value = index;
};
const getPopularRecommenList = async () => {
    const res: any = await getPopularRecommen();
    popularRecommenList.value = res;
    nextTick(() => {
        seamlessWidth.value = popularItem.value[0].offsetWidth + 8;
    });
};
getPopularRecommenList();
const getHomeCategoryList = async () => {
    const res: any = await getHomeCategory();
    categoryList.value = res;
};
getHomeCategoryList();

const getHomeListData = async () => {
    // if (loading.value) return;
    // loading.value = true;
    const res: any = await getHomeList(getListData.value);
    list.value = [...list.value, ...res.items];
    getListData.value.page++;
    loading.value = false;
    finished.value = getListData.value.page * getListData.value.size >= res.totalCount;
};
getHomeListData();

const tabChange = (name: string) => {
    getListData.value.keyword = name;
    getListData.value.page = 1;
    list.value = [];
    getHomeListData();
};

const typeConfirm = (val: any) => {
    isSearchTypeShow.value = false;
    searchType.value = val;
};

const search = () => {
    router.push({
        name: searchType.value.value,
        query: {
            keyword: searchWord.value,
        },
    });
};

const toKefu = () => {
    window.location.href = 'https://work.weixin.qq.com/kfid/kfcdd1c5b9f6d099505';
};
const jumpToWechatApp = (data: any) => {
    getWechatAppUrl(data).then((res: any) => {
        location.href = JSON.parse(res).openlink;
    });
};

const __returned__ = { router, noticeEnum, showregister, addList, list, getListData, loading, finished, images, noticeList, noticeIndex, seamlessWidth, popularItem, popularRecommenList, categoryList, isSearchTypeShow, searchTypes, searchType, searchWord, showpop, close, getAdd, getBannerList, getNotice, noticeChange, getPopularRecommenList, getHomeCategoryList, getHomeListData, tabChange, typeConfirm, search, toKefu, jumpToWechatApp, nextTick, onActivated, onMounted, ref, Vue3SeamlessScroll, getBanner, getNoticeList, getPopularRecommen, getHomeCategory, getHomeList, getWechatAppUrl, getListAdd, getUserInfo, getIsFollow, useRouter, VipTag, userStoreModule }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})